import React from "react";
import cn from "classnames";
import { FALLBACK_COVERART } from "../lib/fallbackCoverart";

const AccordionItem = ({
  genreType,
  answer,
  isOpen,
  onClick,
  setRequestedTrack,
  pickTrack,
  mode,
}) => {
  const contentHeight = React.useRef();
  return (
    <div
      className={cn("wrapper post  text-left text-white", {
        dark: mode === "light",
      })}
    >
      <div
        className={`genreType-container flex flex-row justify-between ${isOpen ? " active" : ""}`}
        onClick={onClick}
      >
        <h4
          className={cn("genreType-content text-lg font-medium uppercase font-black", {
            "text-black": mode === "light",
            "text-white": mode === "dark",
          })}
        >
          {genreType}
        </h4>
        <button className={`${isOpen ? " hide" : ""}`}>
          view playlist
        </button>
        {/* <svg
          className={cn("arrow", {
            "text-black": mode === "light",
            "text-white": mode === "dark",
            active: isOpen,
          })}
          width="20px"
          height="20px"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http:www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke={`${mode === "dark" ? "#ffffff" : "#000000"}`}
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg> */}
      </div>

      <div
        ref={contentHeight}
        className={`answer-container ${isOpen ? "active" : ""}`}
      >
        <ul className="divide-y divide-gray-200">
          {answer.map((item, i) => (
            <li
              className="flex items-center py-4 px-0 jukebox-divider"
              key={i}
              onClick={(event) => {
                setRequestedTrack(item);
                pickTrack(event, item, i);
              }}
            >
              <span className="text-gray-100 text-lg font-black font-medium mr-2">
                {i + 1}
              </span>
              <img
                className=" rounded-full object-cover mr-4"
                src={item.coverart || FALLBACK_COVERART}
                style={{ width: "48px" }}
                alt={item.track}
                onError={(e) => {
                  const src = e.target.getAttribute('data-original-src');
                  if (!src) {
                    e.target.setAttribute('data-original-src', e.target.src);
                    e.target.src = FALLBACK_COVERART;
                    setTimeout(() => {
                      e.target.src = e.target.getAttribute('data-original-src');
                    }, 3000);
                  } else {
                    e.target.onerror = null;
                    e.target.src = FALLBACK_COVERART;
                  }
                }}
              />
              <div className="flex-1 text-left" style={{ width: "50%" }}>
                <h4
                  className={cn(
                    "text-2xl font-bold text-white text-left overflow-hidden"
                  )}
                >
                  {item.track}{" "}
                </h4>
                <p
                  className={cn("text-xl  text-left artist-text")}
                >
                  {item.artist}
                </p>
                <p
                  className={cn("text-xl  text-left artist-text uppercase")}
                >
                  {item.genre}{" "}
                </p>
                {item.currentSong === "true" && (
                  <div
                    className="flex flex-row justify-center  text-left"
                  >
                    <div className="playani"></div>
                  </div>
                )}
              </div>
              <button>request</button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const TrackList = ({ tracks, setRequestedTrack, pickTrack, mode }) => {
  const [activeIndex, setActiveIndex] = React.useState(null);

  const handleItemClick = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  // Group tracks by genre
  const groupedTracks = groupTracksByGenre(tracks);
  // console.log('groupedTracks', groupedTracks);

  return (
    <div className="accordion-list">
      {Object.keys(groupedTracks).sort().map((genre) => (
        <div key={genre} className="accordion-container">
          <AccordionItem
            key={genre}
            genreType={genre}
            answer={groupedTracks[genre]}
            isOpen={activeIndex === genre}
            onClick={() => handleItemClick(genre)}
            setRequestedTrack={setRequestedTrack}
            pickTrack={pickTrack}
            mode={mode}
          />
        </div>
      ))}
    </div>
  );
};

// Utility function to group tracks by genre
const groupTracksByGenre = (tracks) => {
  // console.log('groupTracksByGenre', tracks);
  return tracks.reduce((acc, track) => {
    if (!acc[track.genrekey]) {
      acc[track.genrekey] = [];
    }
    acc[track.genrekey].push(track);
    return acc;
  }, {});
};

const App = ({ data, pickTrack, setRequestedTrack, listTitle, mode }) => (
  <div className="border-none">
    {/* <h2
      className={cn("", {
        "text-black": mode === "light",
        "text-white": mode === "dark",
      })}
    >
      {listTitle}
    </h2> */}
    <TrackList
      tracks={data}
      pickTrack={pickTrack}
      setRequestedTrack={setRequestedTrack}
      mode={mode}
    />
  </div>
);

export default App;
